module.exports = __webpack_public_path__ + "static/home_rimaniaggiornato-15d604b3b877d5e5d572111f90197a68.jpg";